class CategoryListController {

  constructor($timeout, $scope, $state, categoriesService, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.categoriesService = categoriesService;
    this.messageService = messageService;
    this.access = access;
    $scope.treeOptions = {
      dropped: function(sourceNodeScope, destNodesScope, destIndex) {
          $timeout(() => sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure());
        }
    };
  }

  $onInit(){
    if (this.categories){
      this.activeTab = 'tree';
    }else{
      this.activeTab = 'list';
    }

    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.pagedcategories = undefined;
            scope.$ctrl.categoriesService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal, 20).then(response => {
              scope.$ctrl.pagedcategories = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.categoriesService.findAll(newVal, scope.per_page)
            .then(list => scope.$ctrl.pagedcategories = list);
          }
        }
      }
    );
  }

  updatePaging(){
    this.$scope.per_page = this.pagedcategories.per_page;
    this.$scope.current_page = this.pagedcategories.current_page;
    this.$scope.total = this.pagedcategories.total;
  }

  onDelete(category) {
    this.categoriesService.delete(category.id)
      .then(list => {
        this.messageService.success(`The category <strong>${category.name}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`The category <strong>${category.name}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      })
      .then(() => {
        let page = this.pagedcategories.current_page;
        this.pagedcategories = [];
        this.categories = [];
        return Promise.all([
          this.categoriesService.findAll(page).then(response => {
            this.pagedcategories = response;
          }),
          this.categoriesService.hierarchyFind().then(response => {
            this.categories = response;
          })
        ]);
      })
      ;
  }

  saveStructure(){
    this.categoriesService.reconstruct(this.categories.tree)
    .catch(() => {
      this.messageService.failure(`This category structure could not be successfully saved: ${error.statusText}`);
      this.messageService.push();
    })
    .then(() => {
      this.messageService.success(`This category structure has been successfully saved.`);
      this.messageService.push();
      this.messageService.autoClear();
    });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.startFilter();
      this.categoriesService.search(this.filtertype, this.filtertext, 1, 20).then(response => {
        this.isFiltered = true;
        this.endFilter(response);
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.startFilter();
      this.categoriesService.findAll().then(response => {
        this.isFiltered = false;
        this.endFilter(response);
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      default:
        this.filtertext = '';
        break;
    }
  }

  startFilter(){
    this.loading = true;
    this.pagedcategories = undefined;
  }

  endFilter(response){
    this.pagedcategories = response;
    this.updatePaging();
    this.loading = false;
  }
}

CategoryListController.$inject = [ '$timeout', '$scope', '$state', 'categoriesService', 'messageService', 'access' ];

export default CategoryListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/category.list.controller.js